<template lang="html">
	<div>
		<div v-show="showRegister"><Register /></div>
		<div v-show="showLogIn"><LogIn /></div>
		<div v-show="showQuote"><LandingQuote /></div>

		<nav class="fixed top-0 left-0 right-0 z-50 shadow-lg">
			<!-- Top Bar - Contact Information (Desktop Only) -->
			<div class="hidden bg-primary md:block">
				<div class="px-4 mx-auto max-w-7xl sm:px-6 lg:px-8">
					<div class="flex items-center justify-between h-10 text-xs">
						<div class="flex items-center space-x-6 text-white">
							<div class="flex items-center space-x-2">
								<svg
									class="w-4 h-4"
									fill="none"
									stroke="currentColor"
									viewBox="0 0 24 24"
								>
									<path
										stroke-linecap="round"
										stroke-linejoin="round"
										stroke-width="2"
										d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
									/>
								</svg>
								<span class="font-medium">0723 350 348</span>
							</div>
							<div class="flex items-center space-x-2">
								<svg
									class="w-4 h-4"
									fill="none"
									stroke="currentColor"
									viewBox="0 0 24 24"
								>
									<path
										stroke-linecap="round"
										stroke-linejoin="round"
										stroke-width="2"
										d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
									/>
								</svg>
								<span>MON TO FRI 08:00AM - 05:00PM</span>
							</div>
						</div>
						<div class="flex items-center space-x-4">
							<span
								class="font-semibold tracking-wide text-brand-cyan"
								>YOU CAN COUNT ON US</span
							>
						</div>
					</div>
				</div>
			</div>

			<!-- Main Navigation Bar -->
			<div class="bg-white border-b border-gray-200">
				<!-- Mobile Navigation -->
				<div class="md:hidden">
					<div class="px-4 py-3">
						<div class="flex items-center justify-between">
							<div class="flex items-center">
								<button
									@click="toggleNav()"
									class="p-2 transition-colors rounded-lg hover:bg-gray-100"
								>
									<div
										class="space-y-1 navTrigger mainTrigger"
									>
										<div
											class="w-6 h-0.5 bg-primary transition-all duration-300"
										></div>
										<div
											class="w-6 h-0.5 bg-primary transition-all duration-300"
										></div>
										<div
											class="w-6 h-0.5 bg-primary transition-all duration-300"
										></div>
									</div>
								</button>
								<div class="ml-4">
									<div
										class="flex items-center text-lg font-semibold"
									>
										<span class="text-primary">Nexus</span>
										<span class="ml-1 font-bold text-accent"
											>Insurance</span
										>
									</div>
								</div>
							</div>
							<div class="flex items-center space-x-2">
								<button
									class="p-2 transition-colors rounded-lg hover:bg-gray-100"
								>
									<svg
										class="w-5 h-5 text-primary"
										fill="none"
										stroke="currentColor"
										viewBox="0 0 24 24"
									>
										<path
											stroke-linecap="round"
											stroke-linejoin="round"
											stroke-width="2"
											d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
										/>
									</svg>
								</button>
								<div
									v-if="user && user.names"
									class="bg-gray-300 bg-center bg-cover rounded-full w-7 h-7"
									:style="`background-image: url('/img/avatars/2.png')`"
								></div>
							</div>
						</div>
					</div>
				</div>

				<!-- Mobile Menu Overlay -->
				<div v-show="showNav" class="fixed inset-0 z-50 md:hidden">
					<div class="flex h-full">
						<div class="w-64 bg-white shadow-xl">
							<div class="p-6">
								<div class="mb-8">
									<div
										class="flex items-center text-xl font-semibold"
									>
										<span class="text-primary">Nexus</span>
										<span class="ml-1 font-bold text-accent"
											>Insurance</span
										>
									</div>
								</div>

								<!-- Mobile Contact Info -->
								<div
									class="pb-6 mb-6 space-y-3 text-xs border-b border-border"
								>
									<div
										class="flex items-center space-x-2 text-text-secondary"
									>
										<svg
											class="w-4 h-4"
											fill="none"
											stroke="currentColor"
											viewBox="0 0 24 24"
										>
											<path
												stroke-linecap="round"
												stroke-linejoin="round"
												stroke-width="2"
												d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
											/>
										</svg>
										<span class="font-medium"
											>0723350348</span
										>
									</div>
									<div
										class="flex items-center space-x-2 text-text-secondary"
									>
										<svg
											class="w-4 h-4"
											fill="none"
											stroke="currentColor"
											viewBox="0 0 24 24"
										>
											<path
												stroke-linecap="round"
												stroke-linejoin="round"
												stroke-width="2"
												d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
											/>
										</svg>
										<span>MON-FRI 10AM-6PM</span>
									</div>
								</div>

								<div class="space-y-2" @click="toggleNav()">
									<router-link
										v-for="route in routes"
										:key="route.name"
										:to="{ name: route.path }"
										:title="route.tooltip"
										class="block px-4 py-3 font-medium transition-colors rounded-lg text-text-primary hover:bg-primary hover:bg-opacity-10 hover:text-primary"
										:class="{
											'bg-primary bg-opacity-10 text-primary border-l-4 border-accent':
												route.path === $route.name,
										}"
									>
										{{ route.name }}
									</router-link>
									<router-link
										v-if="user && user.names"
										class="block px-4 py-3 font-medium transition-colors rounded-lg text-text-primary hover:bg-primary hover:bg-opacity-10 hover:text-primary"
										:to="{ name: 'Dashboard' }"
										:class="{
											'bg-primary bg-opacity-10 text-primary border-l-4 border-accent':
												'Dashboard' === $route.name,
										}"
									>
										Dashboard
									</router-link>
									<button
										v-if="user && user.names"
										@click="logOut()"
										class="w-full px-4 py-3 font-medium text-left transition-colors rounded-lg text-accent hover:bg-red-50"
									>
										Log Out
									</button>
									<button
										v-if="!user || !user.names"
										@click="logIn()"
										class="w-full px-4 py-3 font-medium text-left transition-colors rounded-lg text-text-primary hover:bg-primary hover:bg-opacity-10 hover:text-primary"
									>
										Log In
									</button>
									<button
										v-if="!user || !user.names"
										@click="Register()"
										class="w-full px-4 py-3 font-medium text-left transition-colors rounded-lg text-text-primary hover:bg-primary hover:bg-opacity-10 hover:text-primary"
									>
										Register
									</button>
								</div>
							</div>
						</div>
						<div
							class="flex-1 bg-black bg-opacity-50"
							@click="toggleNav()"
						></div>
					</div>
				</div>

				<!-- Desktop Navigation -->
				<div class="hidden md:block">
					<div class="px-4 mx-auto max-w-7xl sm:px-6 lg:px-8">
						<div class="flex items-center justify-between h-20">
							<!-- Logo -->
							<div class="flex-shrink-0">
								<div class="text-2xl font-bold">
									<span class="text-primary">Nexus</span>
									<span class="ml-1 text-accent"
										>Insurance</span
									>
								</div>
							</div>

							<!-- Centered Navigation Links -->
							<div
								class="absolute transform -translate-x-1/2 left-1/2"
							>
								<div class="flex items-center space-x-1">
									<router-link
										class="relative px-6 py-2 text-sm font-semibold tracking-wide transition-all duration-300 text-text-primary hover:text-primary group"
										v-for="route in routes"
										:key="route.name"
										:to="{ name: route.path }"
									>
										{{ route.name }}
										<span
											class="absolute bottom-0 left-0 w-0 h-0.5 transition-all duration-300 group-hover:w-full"
											:class="
												route.path === $route.name
													? 'w-full bg-accent'
													: 'bg-primary'
											"
										>
										</span>
									</router-link>

									<router-link
										v-if="isAuthenticated"
										class="relative px-6 py-2 text-sm font-semibold tracking-wide transition-all duration-300 text-text-primary hover:text-primary group"
										:to="{ name: 'NewPortalDashboard' }"
									>
										Dashboard
										<span
											class="absolute bottom-0 left-0 w-0 h-0.5 transition-all duration-300 group-hover:w-full"
											:class="
												'Dashboard' === $route.name
													? 'w-full bg-accent'
													: 'bg-primary'
											"
										>
										</span>
									</router-link>
								</div>
							</div>

							<!-- Right Side: Actions + CTA -->
							<div class="flex items-center space-x-4">
								<button
									title="Search"
									class="p-2.5 transition-all duration-300 rounded-lg hover:bg-primary hover:bg-opacity-10 hover:scale-110"
								>
									<svg
										class="w-5 h-5 text-text-primary"
										fill="none"
										stroke="currentColor"
										viewBox="0 0 24 24"
									>
										<path
											stroke-linecap="round"
											stroke-linejoin="round"
											stroke-width="2"
											d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
										/>
									</svg>
								</button>

								<div
									v-if="isAuthenticated"
									class="flex items-center space-x-3 ml-2"
								>
									<button
										title="Log Out"
										@click="logOut()"
										class="p-2.5 transition-all duration-300 rounded-lg hover:bg-red-50 hover:text-accent hover:scale-110"
									>
										<svg
											class="w-5 h-5 text-text-primary hover:text-accent"
											fill="none"
											stroke="currentColor"
											viewBox="0 0 24 24"
										>
											<path
												stroke-linecap="round"
												stroke-linejoin="round"
												stroke-width="2"
												d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
											/>
										</svg>
									</button>
									<div
										title="Profile"
										class="w-9 h-9 transition-all duration-300 bg-gray-300 bg-center bg-cover border-2 rounded-full cursor-pointer border-border hover:border-primary hover:scale-105 hover:shadow-lg"
										:style="`background-image: url('/img/avatars/2.png')`"
									></div>
								</div>

								<div v-if="!isAuthenticated" class="ml-2">
									<button
										@click="logIn()"
										class="relative px-8 py-2.5 text-sm font-bold text-white overflow-hidden transition-all duration-300 rounded-lg bg-primary hover:bg-primary-light hover:shadow-lg hover:scale-105 group"
									>
										<span class="relative z-10"
											>Client Portal</span
										>
										<span
											class="absolute inset-0 transition-transform duration-300 transform -translate-x-full bg-gradient-to-r from-primary-light to-primary group-hover:translate-x-0"
										></span>
									</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</nav>

		<!-- Spacer to prevent content overlap - Mobile & Desktop heights adjusted -->
		<div class="navbar-spacer"></div>
	</div>
</template>

<script>
import auth from '@/components/auth';

export default {
	components: {
		...auth.components,
		LandingQuote: () => import(`../main/landing/landing-quote`),
		Dropdown: () => import('@/libs/clarks/components/dropdown/dropdown'),
		DropdownItem: () =>
			import('@/libs/clarks/components/dropdown/dropdown-item'),
		DropdownMenu: () =>
			import('@/libs/clarks/components/dropdown/dropdown-menu'),
	},
	computed: {
		...mapGetters('auth', ['isAuthenticated']),
	},
	created() {
		Event.$on('auth:show', (payload) => {
			this.$store.dispatch('alignBoxToCenter', this);

			if (payload.login != undefined) {
				this.showLogIn = payload.login;
			}
			if (payload.register != undefined) {
				this.showRegister = payload.register;
			}
			if (payload.quote != undefined) {
				this.showQuote = payload.quote;
			}
		});
		Event.$on('session:set', async (payload) => {
			if (payload.session_key === 'user') {
				this.user = await $session.get('user');
			}
		});
		Event.$on('session:cleared', (payload) => {
			this.user = undefined;
		});
	},
	methods: {
		...mapActions(['logOutUser']),
		...mapActions('kyc', ['setKycData']),
		...mapActions('quotations', ['setClientQuotationData']),
		toggleNav() {
			// Toggle mobile menu
			this.showNav = !this.showNav;

			// Toggle hamburger animation
			const trigger = this.$el.querySelector('.mainTrigger');
			if (trigger) {
				const lines = trigger.querySelectorAll('div');
				if (this.showNav) {
					lines[0].style.transform = 'rotate(45deg) translateY(6px)';
					lines[1].style.opacity = '0';
					lines[2].style.transform =
						'rotate(-45deg) translateY(-6px)';
				} else {
					lines[0].style.transform = 'none';
					lines[1].style.opacity = '1';
					lines[2].style.transform = 'none';
				}
			}

			if (this.$route.path.includes('user')) {
				const navSide = document.querySelector('.nav-side');
				if (navSide) {
					navSide.classList.toggle('show-mobile');
				}
			}
		},
		logIn() {
			this.$router.push('/insurance/auth');
		},
		Register() {
			this.showLogIn = false;
			this.showQuote = false;
			this.showRegister = true;
		},
		Quote() {
			this.showLogIn = false;
			this.showQuote = true;
			this.showRegister = false;
		},
		async getUser() {
			this.user = await $session.get('user');
		},
		async logOut() {
			await this.$store.dispatch('auth/logout');
			this.setKycData({});
			this.setClientQuotationData([]);

			Event.$emit('auth:logout', true);
			this.$router.push({ name: 'Home' });
		},
	},
	data() {
		return {
			user: null,
			showRegister: false,
			showQuote: false,
			showLogIn: false,
			showNav: false,
			routes: [
				{
					name: 'Home',
					path: 'Home',
					tooltip: 'Buy product or get quotation',
				},
				{
					name: 'About Us',
					path: 'AboutUs',
					tooltip: 'Learn more about Nexus Insurance',
				},
				{
					name: 'Contact Us',
					path: 'ContactUs',
					tooltip: 'Get in touch with our team',
				},
				{
					name: 'Terms',
					path: 'TermsAndConditions',
					tooltip: 'View our Terms&Conditions',
				},
			],
		};
	},
	async mounted() {
		await this.getUser();
	},
};
</script>

<style lang="less" scoped>
/* Custom styles for animations and any remaining functionality */
.navTrigger div {
	transition: all 0.3s ease;
}

/* Tooltip styles */
[title]:hover::after {
	content: attr(title);
	position: absolute;
	background: rgba(0, 0, 0, 0.8);
	color: white;
	padding: 4px 8px;
	border-radius: 4px;
	font-size: 12px;
	white-space: nowrap;
	z-index: 1000;
	top: 100%;
	left: 50%;
	transform: translateX(-50%);
	margin-top: 4px;
}

/* Navbar spacer - responsive height */
.navbar-spacer {
	/* Mobile: just main nav bar */
	height: 70px;

	/* Tablet & Desktop: top bar (40px) + main nav (80px) */
	@media (min-width: 768px) {
		height: 140px;
	}
}
</style>
